import { TFunction } from 'core/i18n/i18n';
import { ExtendedValidationMessages } from 'commons/components';

export const getTrainingRegistrationValidationMessages = (
    t: TFunction
): Record<string, ExtendedValidationMessages> => ({
    ['trainingRegistration-name']: {
        error: {
            'value-missing':
                t('settings.integrations.lms-api-integration.training-registration.name.validation.value-missing') ??
                '',
            duplicated:
                t('settings.integrations.lms-api-integration.training-registration.name.validation.duplicated') ?? '',
        },
    },
    ['trainingRegistration-externalId']: {
        error: {
            'value-missing':
                t(
                    'settings.integrations.lms-api-integration.training-registration.external-id.validation.value-missing'
                ) ?? '',
            duplicated:
                t(
                    'settings.integrations.lms-api-integration.training-registration.external-id.validation.duplicated'
                ) ?? '',
        },
    },
});
